import React, { ReactElement } from "react";
import "./index.scss";

type UserForReviewTaskProps = {
  userDetails: string[];
  checkBox?: ReactElement;
  className?: string;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>
};

export default function UserForReviewTask(props: UserForReviewTaskProps): ReactElement {
  const className = props.className ? `user-review-task-container ${props.className}` : "user-review-task-container";
  return (
    <div
      className={"UserForReviewTask"}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
    >
      <div className={className}>
        {props.checkBox}
        <div className="user-details">
          <div>
            {props.userDetails.map((detail) => {
              return <div key={detail} className="each-user-detail">{detail}</div>;
            })}
          </div>
          <div className="highlight-container">
            <div className="highlight"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
